
















































































import Vue from 'vue';
import VueCompositionAPI, {
  ref,
  defineComponent,
  computed,
} from '@vue/composition-api';
import { useRouter, RouterAliases } from '@/router';
import {
  dropReport,
  getReporterEmail,
  saveReporterEmail,
  submitEmail,
  getReporter,
} from '../store';
import SimpleInput from '@/components/simple-input.vue';
Vue.use(VueCompositionAPI);

function useThankYou(hospitalId: string) {
  /* eslint-disable */
  // @ts-ignore
  window.gtag &&
    // @ts-ignore
    gtag('config', process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID, {
      page_path: `thank-you/${hospitalId}`,
      app_name: 'Patients Care',
    });
  /* eslint-enable */

  const userEmail = computed(() => {
    return getReporterEmail();
  });

  const onEmailChange = (value: string) => {
    saveReporterEmail(value);
  };

  const goHome = () => {
    const router = useRouter();
    submitEmail(hospitalId);
    dropReport();
    router.push({
      name: RouterAliases.DEFAULT_LANDING,
    });
  };

  const whoReported = computed(() => {
    return getReporter() >= 0;
  });
  const who = computed(() => {
    const reporter = getReporter();
    switch (reporter) {
      case 0:
        return 'a Patient';
      case 1:
        return 'a Doctor or Nurse';
      case 2:
        return 'working';
      case 3:
        return 'working in Public Health Department';
    }
  });

  const btnText = computed(() => {
    return 'Home';
  });

  const isEmpty = computed(() => {
    return !userEmail.value;
  });

  return {
    goHome,
    userEmail,
    onEmailChange,
    btnText,
    isEmpty,
    whoReported,
    who,
  };
}

const ThankYouComponent = defineComponent({
  components: {
    SimpleInput,
  },
  props: {
    hospitalId: String,
  },
  setup({ hospitalId }) {
    return { ...useThankYou(hospitalId as string) };
  },
});

export default ThankYouComponent;
